<button
    title="Export CSV"
    mat-stroked-button
    color="primary"
    class="!w-full !h-8 !px-3 !border-primary-700"
    (click)="export()"
>
    <mat-icon fontSet="material-icons-outlined">file_download</mat-icon>
    <span class="text-sm tracking-normal text-nowrap">Export CSV</span>
</button>
